import { render, staticRenderFns } from "./i-post-back.vue?vue&type=template&id=62f3b168&scoped=true&"
import script from "./i-post-back.vue?vue&type=script&lang=js&"
export * from "./i-post-back.vue?vue&type=script&lang=js&"
import style0 from "./i-post-back.vue?vue&type=style&index=0&id=62f3b168&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3b168",
  null
  
)

export default component.exports